import { useQuery } from '@tanstack/react-query';
import { prismService } from '../data-service/prism-service';

export const usePrismSchemas = (version = '') =>
  useQuery({
    queryKey: ['prismSchemas', version],
    queryFn: () => prismService.fetchSchemas(version),
  });
